(function () {
  'use strict';

  if (window.__elitexShippingBar) {
    window.__elitexShippingBar.init(document);
    return;
  }

  var selector = '[data-elitex-shipping-bar]';
  var states = new WeakMap();
  var retryDelays = [100, 300, 1000, 2500, 5000, 10000, 20000, 30000];

  function currencyCode(value) {
    return typeof value === 'string' && /^[A-Z]{3}$/.test(value.trim().toUpperCase())
      ? value.trim().toUpperCase()
      : '';
  }

  function protectAmount(amount) {
    var ignored = window.transcy_ignoreConvertPrice;
    if (!Array.isArray(ignored)) ignored = [];
    if (ignored.indexOf('elitex-shipping-price') === -1) {
      ignored.push('elitex-shipping-price');
    }
    window.transcy_ignoreConvertPrice = ignored;
    if (amount) {
      amount.classList.add('elitex-shipping-price');
      amount.setAttribute('translate', 'no');
    }
  }

  function persistedCurrency() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)transcy_currency=([^;]*)/);
      var code = match ? currencyCode(decodeURIComponent(match[1])) : '';
      if (code) return code;
    } catch (error) {}

    try {
      var stored = window.localStorage.getItem('transcy_currency');
      if (!stored) return '';
      var parsed;
      try {
        parsed = JSON.parse(stored);
      } catch (error) {
        return currencyCode(stored);
      }
      if (typeof parsed === 'string') return currencyCode(parsed);
      if (!parsed || typeof parsed !== 'object') return '';
      var expiry = Date.parse(parsed.expire);
      if (!Number.isFinite(expiry) || expiry <= Date.now()) return '';
      return currencyCode(parsed.value);
    } catch (error) {
      return '';
    }
  }

  function currentCurrency(fallback) {
    var transcy = window._transcy;
    var current = transcy && transcy.variants && currencyCode(transcy.variants.currencyCurrent);
    if (current) return current;
    current = persistedCurrency();
    if (current) return current;
    var shopify = window.Shopify;
    return currencyCode(shopify && shopify.currency && shopify.currency.active) || fallback;
  }

  function readThresholds(root) {
    var config = root.querySelector('script[type="application/json"][data-shipping-config]');
    var source;
    try {
      source = JSON.parse(config ? config.textContent : '{}');
    } catch (error) {
      source = {};
    }
    var thresholds = Object.create(null);
    if (!source || typeof source !== 'object' || Array.isArray(source)) return thresholds;
    Object.keys(source).forEach(function (key) {
      var code = currencyCode(key);
      var value = source[key];
      if (code && typeof value === 'number' && Number.isFinite(value) && value > 0) {
        thresholds[code] = value;
      }
    });
    return thresholds;
  }

  function dismissalKey(root, thresholds) {
    var identity = Object.keys(thresholds).sort().map(function (key) {
      return key + ':' + thresholds[key];
    }).join('|');
    var hash = 0;
    for (var index = 0; index < identity.length; index += 1) {
      hash = ((hash << 5) - hash + identity.charCodeAt(index)) | 0;
    }
    return 'elitex-shipping-bar:' + (root.id || 'default') + ':' + hash;
  }

  function formatAmount(value, code) {
    var language = document.documentElement.lang || undefined;
    var fractionDigits = Number.isInteger(value) ? 0 : 2;
    try {
      return new Intl.NumberFormat(language, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(value);
    } catch (error) {
      return String(value) + ' ' + code;
    }
  }

  function update(root) {
    var state = states.get(root);
    if (!state || state.closed || !root.isConnected) return;
    var code = currentCurrency(state.fallback);
    var threshold = state.thresholds[code];
    var known = typeof threshold === 'number';
    var amount = known ? formatAmount(threshold, code) : '';
    var next = code + '|' + amount;
    if (state.last === next) return;
    state.last = next;
    root.dataset.activeCurrency = code;
    if (state.known) state.known.hidden = !known;
    if (state.unknown) state.unknown.hidden = known;
    if (known && state.amount && state.amount.textContent !== amount) {
      state.amount.textContent = amount;
    }
  }

  function initRoot(root) {
    if (states.has(root)) {
      update(root);
      return;
    }
    var thresholds = readThresholds(root);
    var key = dismissalKey(root, thresholds);
    var closed = false;
    try {
      closed = window.sessionStorage.getItem(key) === 'closed';
    } catch (error) {}
    var state = {
      fallback: currencyCode(root.dataset.currency),
      thresholds: thresholds,
      known: root.querySelector('[data-shipping-known]'),
      unknown: root.querySelector('[data-shipping-unknown]'),
      amount: root.querySelector('[data-shipping-amount]'),
      closed: closed,
      last: null,
      timers: []
    };
    states.set(root, state);
    protectAmount(state.amount);
    if (closed) root.hidden = true;

    var close = root.querySelector('[data-shipping-close]');
    if (close) {
      close.addEventListener('click', function () {
        state.closed = true;
        root.hidden = true;
        state.timers.forEach(window.clearTimeout);
        try {
          window.sessionStorage.setItem(key, 'closed');
        } catch (error) {}
      });
    }
    update(root);
    if (!closed) {
      state.timers = retryDelays.map(function (delay) {
        return window.setTimeout(function () { update(root); }, delay);
      });
    }
  }

  function init(scope) {
    if (scope.matches && scope.matches(selector)) initRoot(scope);
    scope.querySelectorAll(selector).forEach(initRoot);
  }

  function refresh() {
    document.querySelectorAll(selector).forEach(update);
  }

  protectAmount();
  window.__elitexShippingBar = { init: init };
  init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
  window.addEventListener('storage', function (event) {
    if (event.key === 'transcy_currency' || event.key === null) refresh();
  });
}());
